export default [
	{ text: 'APPROVED', value: 'approved' },
	{ text: 'REJECTED', value: 'rejected' },
	{ text: 'DEFERRED', value: 'deferred' }
];



// WEBPACK FOOTER //
// ./src/data/statuses.js